import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Typography,
  Box,
  Divider,
  Stack,
  TextField,
} from "@mui/material";

const ProfileGameStatsExternal = ({ userId }) => {
  const [data, setData] = useState({
    xp: "0",
    kmWalked: "0",
    pokemonCaught: "0",
    pokestopsSpun: "0",
  });

  useEffect(() => {
    const fetchGameStats = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`/api/users/game-stats/${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const newData = {
          xp: String(response.data.xp ?? 0),
          kmWalked: String(response.data.km_walked ?? 0),
          pokemonCaught: String(response.data.pokemon_caught ?? 0),
          pokestopsSpun: String(response.data.pokestops_spun ?? 0),
        };

        setData(newData);
      } catch (err) {
        console.error("Fehler beim Laden der externen Spieldaten:", err);
      }
    };

    if (userId) fetchGameStats();
  }, [userId]);

  const renderRow = (label, value) => (
    <Stack direction="row" alignItems="center" spacing={1} mb={2} key={label}>
      <TextField
        label={label}
        variant="outlined"
        size="small"
        value={value}
        InputProps={{ readOnly: true }}
        sx={{
          flex: 1,
          backgroundColor: (theme) => theme.palette.action.disabledBackground,
        }}
      />
    </Stack>
  );

  return (
    <Box mb={4}>
      <Typography variant="h5" gutterBottom align="center">
        Spieldaten
      </Typography>
      <Divider sx={{ mb: 2 }} />
      {renderRow("Erfahrungspunkte (XP)", data.xp)}
      {renderRow("Gelaufene Kilometer", data.kmWalked)}
      {renderRow("Gefangene Pokémon", data.pokemonCaught)}
      {renderRow("Gedrehte Pokéstops", data.pokestopsSpun)}
    </Box>
  );
};

export default ProfileGameStatsExternal;